import React from 'react';
import { LivingDocuments } from 'components/LivingDocuments';

export const Maintenance = () => (
  <LivingDocuments category="maintenance" />
);
